// extracted by mini-css-extract-plugin
export default {"paragraph":"Paragraph_paragraph__BgCgy","paragraph--source":"Paragraph_paragraph--source__kqPUm"};